/**
 * @FileDescription: 材料管理-类型
 * @Author: fanqixin
 * @Date: 2021-6-30 13:57:53
 * @LastEditors: fanqixin
 * @LastEditTime: 2021-6-30 13:57:53
 */
import axios from '@/api/utils/axios';
import BaseApi from '@/api/utils/baseApi.js'

const CategoryApi = {
	/**
	 * @description: 基础地址
	 */
	baseUrl: function() {
		return '/longstron/material/category';
	},
	getSubsystem:function(){
		return axios.post(this.baseUrl() + "/getSubsystem",{pagination: false});
	},
	getChangeSubsystem:function(){
		return axios.get(this.baseUrl() + "/changeSubsystem/getSubsystem" );
	},
	
};

export default Object.assign(CategoryApi, BaseApi); 
